module.exports = __webpack_public_path__ + "static/main-5502d34a59e410e9b00b321734e8e94a.jpg";